(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dictionary = JSON.parse(root.querySelector('[data-nr-dictionary]').textContent);
    const form = root.querySelector('[data-nr-guide]');
    const status = root.querySelector('[data-nr-status]');
    function update(announce) {
      const result = window.ARVENTO_NR.getGuide(Object.fromEntries(new FormData(form)));
      result.cards.forEach((card, index) => {
        const target = root.querySelector('[data-nr-result="' + index + '"]');
        target.querySelector('[data-nr-text]').textContent = dictionary.guide[card.message].text;
        target.querySelector('[data-nr-why]').textContent = dictionary.guide[card.message].why;
      });
      root.querySelector('[data-nr-context]').textContent = dictionary.guide[result.activity];
      root.querySelector('[data-nr-notices]').textContent = result.notices.map(key => dictionary.guide[key]).join(' ');
      if (announce) status.textContent = dictionary.ui.updated;
    }
    form.addEventListener('change', () => update(true));
    form.addEventListener('reset', () => { window.setTimeout(() => update(true), 0); });
    update(false);

    root.querySelectorAll('[data-nr-tabs]').forEach(group => {
      const tabs = Array.from(group.querySelectorAll('[data-nr-tab]'));
      const panels = Array.from(group.querySelectorAll('[data-nr-panel]'));
      const list = group.querySelector('[data-nr-tablist]');
      list.setAttribute('role', 'tablist');
      function select(index, focus) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
        });
        if (focus) tabs[index].focus();
      }
      tabs.forEach((tab, i) => {
        tab.setAttribute('role','tab');
        tab.setAttribute('aria-controls',panels[i].id);
        panels[i].setAttribute('role','tabpanel');
        panels[i].setAttribute('aria-labelledby',tab.id);
        panels[i].tabIndex = 0;
        tab.addEventListener('click', () => select(i, false));
        tab.addEventListener('keydown', event => {
          const index = event.key === 'ArrowRight' ? (i + 1) % tabs.length : event.key === 'ArrowLeft' ? (i - 1 + tabs.length) % tabs.length : event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : null;
          if (index !== null) { event.preventDefault(); select(index, true); }
        });
      });
      select(0, false);
      list.hidden = false;
    });
  }
  document.querySelectorAll('[data-arvento-nr]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-arvento-nr]').forEach(init));
})();
